var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import { registerIconLibrary } from "@shoelace-style/shoelace/dist/utilities/icon-library.js";
import { iconResolver } from "../utilities/icon-resolver";
registerIconLibrary("wh-icons", iconResolver);
let WhIconElement = class WhIconElement extends LitElement {
    constructor() {
        super(...arguments);
        this.name = "";
        this.label = "";
    }
    render() {
        return html `<sl-icon
      library="wh-icons"
      name=${this.name}
      label=${this.label}
    ></sl-icon>`;
    }
};
WhIconElement.styles = css `
    :host {
      display: inline-flex;
    }
  `;
__decorate([
    property({ type: String })
], WhIconElement.prototype, "name", void 0);
__decorate([
    property({ type: String })
], WhIconElement.prototype, "label", void 0);
WhIconElement = __decorate([
    customElement("wh-icon")
], WhIconElement);
export { WhIconElement };
